import { render, staticRenderFns } from "./LeaveCategories.vue?vue&type=template&id=f6f637b0&scoped=true"
import script from "./LeaveCategories.vue?vue&type=script&lang=js"
export * from "./LeaveCategories.vue?vue&type=script&lang=js"
import style0 from "./LeaveCategories.vue?vue&type=style&index=0&id=f6f637b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f637b0",
  null
  
)

export default component.exports